import React from 'react';
import T from 'prop-types';
import { Card, Row, Tooltip } from 'antd';

import * as Content from '../../../../attrs/content';

import CancelSubscriptionButton from '../../../cancelSubscriptionButton';

import { StyledCol, InfoIcon } from './style';

const CancelSubscriptionCard = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Card>
      <Row align="middle" type="flex">
        <StyledCol sm={12} span={24}>
          Cancel your subscription
          <Tooltip placement="right" title={Content.cancelationInfo}>
            <InfoIcon />
          </Tooltip>
        </StyledCol>
        <StyledCol sm={12} span={24}>
          <CancelSubscriptionButton />
        </StyledCol>
      </Row>
    </Card>
  );
};

CancelSubscriptionCard.propTypes = {
  isVisible: T.bool.isRequired,
};

export default CancelSubscriptionCard;
